import type { ReactNode } from 'react';
import type { IconComponent } from '../../types';
import { CdHeading, CdText } from '../../atoms/CdTypography';
import { cx } from '../../utils';
import styles from './CdPromoBanner.module.scss';

export interface CdPromoBannerProps {
  eyebrow?: string;
  eyebrowIcon?: IconComponent;
  title: string;
  description?: string;
  actions?: ReactNode;
  imageSrc?: string;
  imageAlt?: string;
  className?: string;
}

/** Feature promotion block (e.g. "AI Permit Assistant – Not sure which permit you need?"). */
export const CdPromoBanner = ({
  eyebrow,
  eyebrowIcon: EyebrowIcon,
  title,
  description,
  actions,
  imageSrc,
  imageAlt = '',
  className,
}: CdPromoBannerProps) => {
  return (
    <section className={cx(styles.promo, className)}>
      <div className={styles.content}>
        {eyebrow && (
          <p className={styles.eyebrow}>
            {EyebrowIcon && <EyebrowIcon size={20} aria-hidden="true" />}
            {eyebrow}
          </p>
        )}
        <CdHeading level={2} size="xl">
          {title}
        </CdHeading>
        {description && <CdText>{description}</CdText>}
        {actions && <div className={styles.actions}>{actions}</div>}
      </div>
      <div className={styles.media}>
        {imageSrc ? (
          <img src={imageSrc} alt={imageAlt} loading="lazy" decoding="async" />
        ) : (
          <div className={styles.placeholder} aria-hidden="true" />
        )}
      </div>
    </section>
  );
};
